import statesSelectData from 'modules/addresses/util/states-select-data';
import useCreateCity from 'modules/cities/hooks/use-create-city';
import {
  CityProps,
  OrderSalesByEnum,
  translatedCityProps,
} from 'modules/cities/types';
import {DeliveryModeEnum} from 'modules/companies/types';
import usePaymentMethodsSelect from 'modules/payment-methods/hooks/use-payment-methods-select';
import useSegmentsSelect from 'modules/segments/hooks/use-segments-select';
import React from 'react';
import Creation from 'shared/layout/creation';
import useFormInputs from 'shared/migration-components/form/util';

const CreateCity: React.FC = () => {
  const {
    getInput,
    getSwitch,
    getNumberInput,
    getSelect,
    getMultiSelect,
    getTimePicker,
    getSection,
    getPriceInput,
  } = useFormInputs<CityProps>();

  const segmentsSelect = useSegmentsSelect();
  const paymentMethodSelect = usePaymentMethodsSelect();

  return (
    <Creation<CityProps>
      titleBar={{title: 'Cadastrar cidade'}}
      onSubmit={useCreateCity}
      inputs={[
        getInput({
          name: 'name',
        }),
        getInput({
          name: 'phone',
          mask: 'phone',
        }),
        getSelect({name: 'state', data: statesSelectData}),
        getSwitch({
          name: 'active',
        }),
        getSelect({
          name: 'deliveryMode',
          data: [
            {label: 'Grátis', value: DeliveryModeEnum.free},
            {label: 'Preço fixo', value: DeliveryModeEnum.fixed},
            {label: 'Bairro/Distância', value: DeliveryModeEnum.neighborhood},
          ],
        }),
        getPriceInput({
          name: 'deliveryPrice',
          hidden: (data) => data.deliveryMode !== DeliveryModeEnum.fixed,
        }),
        getSwitch({
          name: 'withCashback',
        }),
        getNumberInput({
          name: 'cashback',
          hidden: (data) => !data.withCashback,
          gridColumn: 6,
        }),
        getNumberInput({
          name: 'cashbackExpiration',
          hidden: (data) => !data.withCashback,
          gridColumn: 6,
        }),
        getSelect({
          name: 'billingRecorency',
          data: [
            {label: 'Semanal', value: 'WEEKLY'},
            {label: 'Quinzenal', value: 'FORTNIGHTLY'},
            {label: 'Mensal', value: 'MONTHLY'},
          ],
        }),
        getNumberInput({
          name: 'cityFee',
        }),
        getTimePicker({name: 'availableDeliveriesStartsAt', gridColumn: 6}),
        getTimePicker({name: 'availableDeliveriesEndsAt', gridColumn: 6}),
        getMultiSelect({
          name: 'segmentsIds',
          data: segmentsSelect.data,
        }),
        getMultiSelect({
          name: 'paymentMethodsIds',
          data: paymentMethodSelect.data,
        }),
        getMultiSelect({
          name: 'guestPaymentMethodsIds',
          data: paymentMethodSelect.data,
        }),
        getSelect({
          name: 'orderSalesBy',
          data: [
            {
              label: 'Distância',
              value: OrderSalesByEnum.distance,
            },
            {
              label: 'Preço crescente',
              value: OrderSalesByEnum.price_ascending,
            },
            {
              label: 'Preço decrescente',
              value: OrderSalesByEnum.price_descending,
            },
            {
              label: 'Desconto crescente',
              value: OrderSalesByEnum.discount_ascending,
            },
            {
              label: 'Desconto decrescente',
              value: OrderSalesByEnum.discount_descending,
            },
          ],
        }),
        getSection({
          label: 'Integração Mercado Pago',
          inputs: [
            getInput({name: 'mercadoPagoToken'}),
            getInput({name: 'mercadoPagoPublicKey'}),
          ],
        }),
      ]}
      translationKey={translatedCityProps}
    />
  );
};

export default CreateCity;
